// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap___34qop","compact":"compact___3sms_","pending":"pending___2rAgs","desc":"desc___3utQY","hint":"hint___3YBAf","action":"action___25cli"};